import React, { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

const ContactPage: React.FC = () => {
  // SEO Configuration
  useSEO({
    title: '下載訂購單與聯絡我們 - 房仲專用買賣契約書 | 全台服務',
    description: '聯絡房仲專用買賣契約書，提供訂購單下載、電話諮詢、Line聯繫等服務。服務全台灣不動產仲介業者，電話：04-35023788，週一至週五 09:00-18:00。',
    keywords: '聯絡我們,訂購單下載,契約書訂購,全台服務,房仲契約諮詢',
    canonical: '/contact',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema(
          '下載訂購單與聯絡我們',
          '聯絡房仲專用買賣契約書，提供訂購單下載、電話諮詢、Line聯繫等服務，服務全台灣',
          '/contact'
        ),
        generateBreadcrumbSchema([
          { name: '首頁', url: '/' },
          { name: '聯絡我們', url: '/contact' }
        ])
      ]
    }
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-2xl sm:text-4xl font-bold text-gray-800 mb-4">下載訂購單與聯絡我們</h1>
            <p className="text-lg text-gray-600">
              有任何問題或建議，歡迎與我們聯繫
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-2xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-[#d4af37]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">電話聯絡</h3>
              <p className="text-gray-600 mb-2">週一至週五 09:00-18:00</p>
              <a href="tel:04-35023788" className="text-[#d4af37] font-semibold hover:text-[#c49d2e] transition-colors duration-300 block mb-2">
                04-35023788
              </a>
              <p className="text-sm text-gray-500">
                傳真：04-22475540
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-[#d4af37]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-fill text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Line</h3>
              <p className="text-gray-600 mb-4">24小時內回覆</p>
              <p className="text-[#d4af37] font-semibold">
                楊小姐
              </p>
              <p className="text-[#d4af37] font-semibold">
                LINE ID: ivanok88
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-[#d4af37]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-3xl text-[#d4af37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">公司地址</h3>
              <p className="text-gray-600 mb-4">現場購買請先來電約時間</p>
              <p className="text-[#d4af37] font-semibold">
                台中市北屯區崇德二路二段8號
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">訂購單下載</h2>
              <p className="text-gray-600">
                點擊後可下載excel檔，請下載到自己電腦更改後再傳給我們的Line。或填寫右上角的電子表單，我們確認後會與你們聯絡
              </p>
            </div>
            
            <div className="flex justify-center">
              <a 
                href="https://docs.google.com/spreadsheets/d/100rT6lFFx35OMyQ2SV7CFF31rVtiOUoD/edit?usp=sharing&ouid=118384847509960706591&rtpof=true&sd=true" 
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer hover:opacity-90 transition-opacity duration-300 group"
              >
                <img 
                  src="https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/b925b145af54a3df482c210bbd3eebfd.jpeg" 
                  alt="契約書訂購明細表" 
                  className="max-w-full h-auto rounded-lg shadow-lg group-hover:shadow-xl transition-shadow duration-300"
                />
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center gap-2 text-[#d4af37] font-semibold group-hover:text-[#c49d2e] transition-colors duration-300">
                    <i className="ri-download-line text-xl"></i>
                    點擊圖片開啟訂購單
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
